// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { UserDTO } from './user-dto';

/**
 * 
 * @export
 * @interface TenancyInventoryRespondentDTO
 */
export interface TenancyInventoryRespondentDTO {
    /**
     * 
     * @type {string}
     * @memberof TenancyInventoryRespondentDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TenancyInventoryRespondentDTO
     */
    tenancyInventoryId: string;
    /**
     * 
     * @type {UserDTO}
     * @memberof TenancyInventoryRespondentDTO
     */
    user: UserDTO;
    /**
     * 
     * @type {string}
     * @memberof TenancyInventoryRespondentDTO
     */
    response?: TenancyInventoryRespondentDTOResponseEnum;
    /**
     * 
     * @type {string}
     * @memberof TenancyInventoryRespondentDTO
     */
    stage: TenancyInventoryRespondentDTOStageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyInventoryRespondentDTO
     */
    warningsActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TenancyInventoryRespondentDTO
     */
    respondedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum TenancyInventoryRespondentDTOResponseEnum {
    CONFIRMED = 'CONFIRMED',
    UNCONFIRMED = 'UNCONFIRMED'
}
/**
    * @export
    * @enum {string}
    */
export enum TenancyInventoryRespondentDTOStageEnum {
    EARLY = 'EARLY',
    LATE = 'LATE',
    FINAL = 'FINAL'
}



